import { Stack } from '@mui/material';
import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { spaces } from '../../../../../assets/styles/themes/tokens';
import { getCurrentConversation } from '../../../../../reducers/aiAssistant.selectors';
import {
	AIAssistantDisplayMode,
	aiAssistantContext,
} from '../../../../../state/AIAssistantContextProvider';
import { aiAssistantEditorContext } from '../../../../../state/AIAssistantEditorProvider';
import useScreenSize from '../../../../../utils/useScreenSize';
import useIsPodcastLoadingViewActive from '../useIsPodcastLoadingViewActive';
import AIAssistantMessage from './AIAssistantMessage';
import AIAssistantStreamedMessage from './AIAssistantStreamedMessage';
import AIAssistantUserMessage from './AIAssistantUserMessage';

const AIAssistantMessages = () => {
	const { dialogMessagesContainerRef, displayMode } = useContext(aiAssistantContext);
	const currentConversation = useSelector(getCurrentConversation);
	const isDialogMode = displayMode === AIAssistantDisplayMode.DIALOG;
	const isPageMode = displayMode === AIAssistantDisplayMode.PAGE;
	const { isTextEditorOpen } = useContext(aiAssistantEditorContext);
	const { isXsScreen, isSmScreen } = useScreenSize();
	const isXsOrSmScreen = isXsScreen || isSmScreen;
	const isPodcastLoadingViewActive = useIsPodcastLoadingViewActive();
	// Podcast loading stands in for the editor, so both mean the slim split panel is open.
	const isDetailPaneOpen = isTextEditorOpen || isPodcastLoadingViewActive;

	const currentConversationMessages = currentConversation?.data?.messages ?? [];
	const shouldUseCompactPadding = isDialogMode || isXsOrSmScreen || (isPageMode && isDetailPaneOpen);

	return (
		<Stack
			sx={{
				padding: shouldUseCompactPadding ? spaces.md : spaces.xxl,
				maxWidth: '1440px',
				margin: '0 auto',
			}}
			ref={dialogMessagesContainerRef}
			data-testid="ai-assistant-chat-messages"
		>
			{currentConversationMessages.map((message, index) =>
				message.role === 'user' ? (
					// biome-ignore lint/suspicious/noArrayIndexKey: index keys are pre-existing; switching the key source changes reconciliation behavior
					<AIAssistantUserMessage message={message} key={index} />
				) : (
					<AIAssistantMessage
						message={message}
						isLast={index === currentConversationMessages.length - 1}
						withRegenerateButton={index === currentConversationMessages.length - 1}
						// biome-ignore lint/suspicious/noArrayIndexKey: index keys are pre-existing; switching the key source changes reconciliation behavior
						key={index}
					/>
				)
			)}
			<AIAssistantStreamedMessage />
		</Stack>
	);
};

export default AIAssistantMessages;
